module.exports = __webpack_public_path__ + "img/prize-top-bg.69ed6ac.png";